export default "__VITE_ASSET__ebeeb1cc__"